/* import __COLOCATED_TEMPLATE__ from './team-assignee-row.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const TeamAssigneeRow = templateOnlyComponent<Signature>();
export default TeamAssigneeRow;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::TeamAssigneeRow': typeof TeamAssigneeRow;
    'inbox2/conversation-details-sidebar/team-assignee-row': typeof TeamAssigneeRow;
  }
}
